import React from 'react'
import { Link, useParams } from 'react-router-dom'
import { AiFillCaretUp } from 'react-icons/ai';
import {AiFillCaretDown} from 'react-icons/ai';
import { useState } from 'react';
import  moment  from 'moment';
import copy from 'copy-to-clipboard'
import './Questions.css'
import Avatar from '../../components/Avatar/Avatar'
import { useLocation } from 'react-router-dom';
import DisplayAnswer from './DisplayAnswer';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { postAnswer,deleteQuestion,voteQuestion }from '../../actions/question'


const QuestionsDetails = () => {

     const {id}=useParams()
     const questionList=useSelector(state => state.questionsReducer)
    //  console.log(questionList)
    //  console.log(id);
    // var questionList=[
    //     {
    //     _id:'1',
    //     upVotes:3,
    //     downVotes:2,
    //     noOfAnswer:2,
    //     questionTitle:"What is a function",
    //     questionBody:"It mean to be",
    //     questionTags:["java","node.js","react js","mongodb"],
    //     userPosted:"mano",
    //     askedOn:"jan1",
    //     userId:1,
    //     answer:[{
    //       answerBody:"Answer",
    //       userAnswered:'kumar',
    //       answeredOn:"jan 2",
    //       userId:2,
    //     }]
    //   },
    
    //   {
    //     _id:'2',
    //     upVotes:3,
    //     downVotes:2,
    //     noOfAnswer:0,
    //     questionTitle:"What is a function",
    //     questionBody:"It mean to be",
    //     questionTags:["java","node.js","react js","mongodb"],
    //     userPosted:"mano",
    //     askedOn:"jan1",
    //     userId:1,
    //     answer:[{
    //       answerBody:"Answer",
    //       userAnswered:'kumar',
    //       answeredOn:"jan 2",
    //       userId:2,
    //     }]
    //   },
    
    //   {
    //     _id:'3',
    //     upVotes:3,
    //     downVotes:2,
    //     noOfAnswer:0,
    //     questionTitle:"What is a function",
    //     questionBody:"It mean to be",
    //     questionTags:["java","node.js","react js","mongodb"],
    //     userPosted:"mano",
    //     askedOn:"jan1",
    //     userId:1,
    //     answer:[{
    //       answerBody:"Answer",
    //       userAnswered:'kumar',
    //       answeredOn:"jan 2",
    //       userId:2,
    //     }]
    //   }
    
    // ]
    const Navigate=useNavigate()
    const dispatch =useDispatch()
  const [Answer,setAnswer]=useState('')
  const User=useSelector((state)=>(state.currentUserReducer))
  const location=useLocation()
  const url='https://onlyserver-production.up.railway.app'
//   const handlePostAns =(e,answerLength )=>{
//          e.preventDefault()
//          if(User===null){
//              alert('Login first to answer')
//              Navigate('/Auth')
//          }else{

//              if(Answer === ''){
//                 alert('Enter your answer before submit')
//             }else{
//                 dispatch(postAnswer({ id, noOfAnswers:answerLength + 1, answerBody:Answer, userAnswered:User.result.name}))
//             }
//          }
//   }


 const handleShare = () => {
   copy(url+location.pathname )
   alert('Copied url :'+url+location.pathname)
 }

 const handleDelete=() =>{
    dispatch(deleteQuestion(id,Navigate))
 }





const handlePostAns = (e, answerLength) =>{
    e.preventDefault()
    if(User === null){
        alert('Login or Signup to answer a question')
        Navigate('/Auth')
    }else{
        if(Answer === ''){
            alert('Enter an answer before submitting')
        } else{
            dispatch(postAnswer({ id, noOfAnswers: answerLength + 1, answerBody: Answer, userAnswered: User.result.name,userId:User.result._id }))
          
        }
    }
}

const handleUpVote=()=>{
  console.log("i am inside upvotes")
  dispatch(voteQuestion(id, 'upVotes', User.result._id))
}

const handleDownVote=()=>{
  console.log("i am inside downvotes")
    dispatch(voteQuestion(id, 'downVotes', User.result._id))
    
  }


     
  return (
    <div className='question-details-page'>
       {
        questionList.data===null ?
        <h1>Loading...</h1>:
        <>
          {
            questionList.data.filter(question=>question._id===id).map(question=>(
                <div key={question._id}>
                   {console.log(question)} 
                     <section className='question-details-container'>
                        <h1>{question.questionTitle}</h1>
                    <div className='question-details-container-2'>
                        <div className="question-votes">
                            <AiFillCaretUp className='votes-icon' onClick={handleUpVote}/>
                            <p>{question.upVotes.length - question.downVotes.length}</p>
                            <AiFillCaretDown className='votes-icon' onClick={handleDownVote}/>
                        </div>
                        <div style={{width:"100%"}}>
                              <p className='question-body'>{question.questionBody}</p>
                              <div className="question-details-tags">
                                {
                                    question.questionTags.map((tag)=>(
                                        <p key={tag}>{tag}</p>
                                    ))
                                }
                              </div>
                              <div className="question-action-user">
                                <div>
                                    <button type='button' onClick={handleShare}>Share</button>

                                    {
                                        User?.result?._id ===question?.userId && (
                                            <button type='button' onClick={handleDelete}>Delete</button>
                                        )
                                    }

                                   
                                </div>
                                <div>
                                    <p>Asked {moment(question.askedOn).fromNow()}</p>
                                    <Link to={`/User/${question.userId}`} className='user-link' style={{color:'#0086d8'}}>
                                        <Avatar backgroundColor="orange" px='8px' py='5px'>{question.userPosted.charAt(0).toUpperCase()}</Avatar>
                                        <div>{question.userPosted}</div>
                                    </Link>
                                </div>
                              </div>
                        </div>
                    </div>
                     </section>
                     {
                        
                            question.noOfAnswers !== 0 && (
                            <section>
                              <h3>{question.noOfAnswers} Answers</h3>
                              <DisplayAnswer key={question._id} question={question}  handleShare={handleShare}/>
                             </section>
                                    )
                                }


                     <section className='post-ans-container'>
                        <h3>Your Answer</h3>
                        <form onSubmit={ (e)=>{handlePostAns(e,question.answer.length)}} >
                            <textarea name='' id='' cols='30' rows='10' onChange={e => setAnswer(e.target.value)}/>
                            <br/>
                            <input type='submit' className='post-ans-btn' value='Post Your Answer'/>
                        </form>
                        <p>Browse other Question tagged
                            {
                                question.questionTags.map((tag)=>(
                                    <Link to='/Tags' key={tag} className='ans-tags'> {tag} </Link>
                                ))
                            }or
                            <Link to='/AskQuestion' style={{textDecoration:"none",color:"#009dff"}}>ask Your own question.</Link>

                            
                        </p>
                     </section>
                     </div>
            ))
          }
        </>
       }
    </div>
  )
}

export default QuestionsDetails